<template>
    <div>
        <b-modal
            id="requisitionFormModal"
            ref="requisitionFormModal"
            :scrollable="true"
            :lazy="true"
            title-tag="h2"
            no-close-on-backdrop
            title="Print Requisition Form"
        >
            <!-- Modal Form -->
            <div
                v-if="errorSource.length > 0"
                class="alert alert-warning"
                role="alert"
            >
                We are currently unable to connect to
                {{ errorSource.join(", ") }} Please try submitting these orders
                again later.
            </div>
            <p>
                Your lab request has been successfully submitted to
                {{ lab_name }}. Click on "Print" to print the requisition form
                for the sample to be submitted.
            </p>

            <div slot="modal-footer" class="w-100">
                <b-btn
                    @click="$refs.requisitionFormModal.hide()"
                    v-if="!loading"
                    class="float-left"
                    variant="secondary"
                    >Cancel</b-btn
                >
                <div v-if="loading" class="float-right">
                    <img v-if="loading" src="assets/ajax-loader.gif" />
                </div>
                <div v-else class="float-right">
                    <b-btn @click="print" variant="primary">Print</b-btn>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
export default {
    components: {},
    data() {
        return {
            lab_name: "-",
            form_url: "",
            znlab: false,
            znlab_id: null,
            loading: false,
            param_data: [],
            errorSource: []
        };
    },
    computed: {},
    methods: {
        open(params) {
            let self = this;
            self.param_data = params;

            if (params.connection_error) {
                if (params.lab_connection_error.length > 0) {
                    _.forEach(params.lab_connection_error, function (source) {
                        switch (source) {
                            case "ANTECH":
                            case "ANTECH_WEST":
                            case "ANTECH_EAST":
                                self.errorSource.push("Antech");
                                break;
                            case "ZNLABS":
                                self.errorSource.push("Zoetis");
                                break;
                            case "MIDWEST":
                                self.errorSource.push(
                                    "Midwest Veterinary Laboratory"
                                );
                                break;
                            case "NBIOVET":
                                self.errorSource.push("National Biovet");
                                break;
                            case "IDEXX":
                                self.errorSource.push("IDEXX");
                                break;
                            case "VETEK":
                                self.errorSource.push("VETEK");
                                break;
                            case "MICROVET":
                                self.errorSource.push("MICROVET");
                                break;
                            case "BIONOTE":
                                self.errorSource.push("BIONOTE");
                                break;
                        }
                    });
                }
            }

            switch (params.lab.source) {
                case "ANTECH_WEST":
                case "ANTECH_EAST":
                case "ANTECH":
                    self.lab_name = "Antech";
                    if (params.lab.requisition_form_url) {
                        self.form_url = params.lab.requisition_form_url;
                    }
                    break;
                case "IDEXX":
                    self.lab_name = "IDEXX";
                    break;
                case "ZNLABS":
                    self.lab_name = "Zoetis";
                    break;
                case "MIDWEST":
                    self.lab_name = "Midwest Veterinary Laboratory";
                    break;
                case "NBIOVET":
                    self.lab_name = "National Biovet";
                    break;
                case "VETEK":
                    self.lab_name = "VETEK";
                    break;
                case "MICROVET":
                    self.lab_name = "MICROVET";
                    break;
                case "BIONOTE":
                    self.lab_name = "BIONOTE";
                    break;
            }

            self.$refs.requisitionFormModal.show();
        },
        print() {
            let self = this;
            self.loading = true;
            let mod = self.param_data.module;
            let lab_id = self.param_data.lab.id;
            let url = self.param_data.module_url;

            if (
                _.get(self, "param_data.lab.source") == "IDEXX" ||
                _.get(self, "param_data.lab.source") == "ZNLABS" ||
                _.get(self, "param_data.lab.source") == "MIDWEST" ||
                _.get(self, "param_data.lab.source") == "NBIOVET" ||
                _.get(self, "param_data.lab.source") == "VETEK" ||
                _.get(self, "param_data.lab.source") == "MICROVET" ||
                _.get(self, "param_data.lab.source") == "BIONOTE"
            ) {
                $.get(
                    process.env.APPS +
                        "index.php/patient/lab/get_requisition_form_url?lab_id=" +
                        lab_id
                ).then(function (response) {
                    window.open(response.idexx_url, "_blank");

                    self.$refs.requisitionFormModal.hide();
                    self.$root.$emit("dialog-closed");

                    if (url != "") {
                        switch (mod) {
                            case "client_profile":
                            case "invoice_dashboard":
                                window.location.href =
                                    process.env.APPS + "index.php/" + url;
                                break;
                            default:
                                break;
                        }
                    }
                });
            } else {
                window.open(self.form_url, "_blank");

                if (url != "") {
                    switch (mod) {
                        case "client_profile":
                        case "invoice_dashboard":
                            window.location.href =
                                process.env.APPS + "index.php/" + url;
                            break;
                        default:
                            break;
                    }
                }

                self.$refs.requisitionFormModal.hide();
            }
        }
    }
};
</script>
